import { trackAnalyticsEvent } from "../api/analyticsApi";

const SESSION_KEY = "bead_growth_session";
const SOURCE_KEY = "bead_growth_source";
const ATTRIBUTION_KEY = "bead_growth_attribution";

function stored(key, fallback = "") {
  try { return window.localStorage.getItem(key) || fallback; } catch (error) { return fallback; }
}

function ensureSession() {
  let id = stored(SESSION_KEY);
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    try { window.localStorage.setItem(SESSION_KEY, id); } catch (error) { /* restricted storage */ }
  }
  return id;
}

function compact(value, maxLength = 80) {
  const first = Array.isArray(value) ? value[0] : value;
  return first == null ? "" : String(first).trim().slice(0, maxLength);
}

function storedJson(key) {
  try {
    return JSON.parse(window.localStorage.getItem(key) || "{}");
  } catch (error) {
    return {};
  }
}

export function useAnalytics() {
  function rememberSource(value) {
    if (!value) return stored(SOURCE_KEY, "direct");
    try { window.localStorage.setItem(SOURCE_KEY, String(value).slice(0, 80)); } catch (error) { /* restricted storage */ }
    return String(value).slice(0, 80);
  }

  function rememberAttribution(query = {}) {
    const previous = storedJson(ATTRIBUTION_KEY);
    const current = {
      source: compact(query.utm_source || query.source),
      medium: compact(query.utm_medium),
      campaign: compact(query.utm_campaign),
      content: compact(query.utm_content),
      term: compact(query.utm_term),
      referral: compact(query.ref || query.referral || query.invite)
    };
    const incoming = Object.fromEntries(Object.entries(current).filter(([, value]) => value));
    const attribution = Object.keys(incoming).length ? { ...previous, ...incoming } : previous;

    if (Object.keys(attribution).length) {
      try { window.localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution)); } catch (error) { /* restricted storage */ }
    }
    if (attribution.source) rememberSource(attribution.source);
    return attribution;
  }

  function track(eventName, extra = {}) {
    const attribution = rememberAttribution(extra.attribution || {});
    const source = rememberSource(extra.source || attribution.source);
    const customMetadata = extra.metadata && typeof extra.metadata === "object" ? extra.metadata : {};
    const metadata = { ...attribution, ...customMetadata };
    const payload = {
      eventName,
      source,
      path: extra.path || `${window.location.pathname}${window.location.search}`,
      workId: extra.workId ? Number(extra.workId) : undefined,
      sessionId: ensureSession(),
      metadata: Object.keys(metadata).length ? JSON.stringify(metadata).slice(0, 1000) : undefined
    };
    trackAnalyticsEvent(payload).catch(() => {});
  }

  return { track, rememberSource, rememberAttribution };
}
